import DefaulteImage from "../Views/Utilisateure/visiteur/DefaulteImage.jpeg";

const getBaseUrl = (): string => {
  let base = (process.env.REACT_APP_PHP_APP_URL || "http://127.0.0.1:8000/api").replace(/\/api\/?$/, "");
  if (typeof window !== "undefined") {
    const currentHost = window.location.hostname;
    if (currentHost === "localhost" && base.includes("127.0.0.1")) {
      base = base.replace("127.0.0.1", "localhost");
    } else if (currentHost === "127.0.0.1" && base.includes("localhost")) {
      base = base.replace("localhost", "127.0.0.1");
    }
  }
  return base;
};

/**
 * Returns a fully qualified image URL for product images.
 * Handles relative paths (storage/...), local backend storage URLs (http://localhost/storage/...),
 * and external full URLs (http/https/data).
 */
export const getFormattedImageUrl = (url?: string): string => {
  if (!url || typeof url !== "string" || url.trim() === "") {
    return DefaulteImage;
  }
  const cleanUrl = url.trim();

  // Data / blob URLs
  if (cleanUrl.startsWith("data:") || cleanUrl.startsWith("blob:")) {
    return cleanUrl;
  }

  const baseUrl = getBaseUrl();

  // Normalize any Laravel storage URL (e.g. http://localhost/storage/..., http://127.0.0.1:8000/storage/..., /storage/...)
  const storageIndex = cleanUrl.indexOf("/storage/");
  if (storageIndex !== -1) {
    const storagePath = cleanUrl.slice(storageIndex + 1); // "storage/..."
    return `${baseUrl}/${storagePath}`;
  }

  if (cleanUrl.startsWith("storage/")) {
    return `${baseUrl}/${cleanUrl}`;
  }

  if (cleanUrl.startsWith("http://") || cleanUrl.startsWith("https://")) {
    return cleanUrl;
  }

  const relativePath = cleanUrl.startsWith("/") ? cleanUrl.slice(1) : cleanUrl;
  return `${baseUrl}/storage/${relativePath}`;
};

/**
 * Fallback handler for img onError events.
 * Swaps broken/missing images with DefaulteImage to avoid white/blank frames.
 */
export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
  e.currentTarget.onerror = null;
  e.currentTarget.src = DefaulteImage;
};
